import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import config from "./app-config.json";

i18n
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    fallbackLng: "appstudio",
    //debug: true,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: config?.language,
      requestOptions: {
        cache: "no-store",
      },
    },
  });

export default i18n;
